import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { NotifyService } from "../../notify/notify.service";
import { TOAST } from "../../notify/toast/toast-type.enum";
import { toastKey } from "../../notify/toast-key.const";

export const msalInterceptor: HttpInterceptorFn = (request, next) => {
  const notifyService = inject(NotifyService);

  return next(request).pipe(
    catchError((error) => {
      if (error.error && error.error.code && error.error.code === 1001) {
        notifyService.toast(
          TOAST.ERROR,
          "Office365 Session Expired",
          "Please log in again using the button below",
          true,
          toastKey.msal,
        );
      }

      return throwError(error);
    }),
  );
};
